import { useSnackBar } from "hooks/useSnackBar";
import { useGetAllExpeditionCategsQuery } from "redux/api/delivery/expeditionCategs/expeditionCategs";

export default function useExpeditionCategoriesListAll() {
  const { displayErrorApiSnackBar } = useSnackBar();

  const {
    data: catgorievalues,
    error,
    isLoading,
  } = useGetAllExpeditionCategsQuery({
    paginator: {
      search: "",
      page: 1,
      perPage: 999, // Override default to fetch all categories
      orderBy: "created_at",
      orderDir: "desc",
    },
  });

  if (error) {
    displayErrorApiSnackBar(error);
  }

  return {
    catgorievalues,
    isLoading
  };
}
